import React from 'react';
import WebView from 'react-native-webview'

const quote = () => {
    return <WebView source={{ uri: 'https://rioben.org.br/cotacao.html' }} />;
}

export default quote;